const combinePath = (path, id) => `${path}.${id}`
const getPath = (path, id) => `${combinePath(path, id)}.values`
const getUiPath = (id) => `uiState.formElements.${id}`

export {
  combinePath,
  getPath,
  getUiPath
}
